import { Controller } from "@hotwired/stimulus";
import { toggleClass } from "../../utils/misc";
import { postTurboRequest } from "../../utils/http_utils";
import { isEmpty } from "../../components/dropzone";

export default class extends Controller {
  static targets = ["dropzone", "errorMessage"];

  submitForm(event) {
    event.preventDefault();

    const hasMissingFiles = this.dropzoneTargets.some((dropzoneElement) => isEmpty(dropzoneElement.dropzone));
    toggleClass(this.errorMessageTarget, "hidden", hasMissingFiles);

    if (hasMissingFiles) {
      return;
    }

    const files = this._appendFiles();
    postTurboRequest(this.element.action, files);
  }

  _appendFiles() {
    const formData = new FormData(this.element);

    this.dropzoneTargets.forEach((dropzoneElement) => {
      const dropzone = dropzoneElement.dropzone;
      const kind = dropzoneElement.dataset.madelinStatementKind;
      const id = dropzoneElement.dataset.madelinDocumentId;
      dropzone.files.forEach((file) => {
        formData.append(`${kind}[id]`, id);
        formData.append(`${kind}[file]`, file);
      });
    });

    return formData;
  }
}
